import * as _ from "lodash-core";
import {
  ConditionalRequiredHiddenButtons,
  ConditionalShowHideButtons,
  ThenRuleEditorComponentType,
} from "@graffer-inc/form-builder";
import { ToggleField, useToggleField } from "@graffer-inc/smart-apply";
import { isFunctionElement, isInputElement } from "@graffer-inc/form-schema";

export const ApplicantThenRuleEditor: ThenRuleEditorComponentType = ({
  thenRule: r,
  onUpdate,
  thenCandidates,
  element,
}) => {
  const { isOn, setOff, setOn } = useToggleField(!!r.rule.label?.text);

  return (
    <>
      <div className="field">
        <label className="label">適用対象</label>
        <p className="control">
          {thenCandidates.find((e) => e.id === r.id)!.label.text}
        </p>
      </div>
      <ToggleField label="項目名" isOn={isOn} setOn={setOn} setOff={setOff}>
        <div className="control">
          <input
            className="input"
            placeholder="ラベル名"
            value={r.rule.label?.text || ""}
            onChange={(e) => {
              if (e.target.value === "") {
                const copied = {
                  ...r,
                  rule: {
                    ...r.rule,
                    label: {
                      ...r.rule.label,
                    },
                  },
                };
                if (!_.unset(copied, "rule.label.text")) {
                  throw new Error(`failed to unset "rule.label.text"`);
                }
                onUpdate(copied);
              } else {
                onUpdate({
                  ...r,
                  rule: {
                    ...r.rule,
                    label: {
                      ...r.rule.label,
                      text: e.target.value,
                    },
                  },
                });
              }
            }}
          />
        </div>
      </ToggleField>
      {isInputElement(element) && (
        <div className="field">
          <label className="label">必須・表示設定</label>
          <ConditionalRequiredHiddenButtons
            rule={r.rule}
            element={element}
            onUpdate={(newRule) => {
              onUpdate({
                ...r,
                rule: {
                  ...r.rule,
                  ...newRule,
                },
              });
            }}
          />
        </div>
      )}
      {isFunctionElement(element) && (
        <div className="field">
          <label className="label">表示・非表示設定</label>
          <ConditionalShowHideButtons
            rule={r.rule}
            onUpdate={(newRule) => {
              onUpdate({
                ...r,
                rule: {
                  ...r.rule,
                  ...newRule,
                },
              });
            }}
          />
        </div>
      )}
    </>
  );
};
